import {
  Button,
  Container,
  Stack,
  Text,
  Image,
  Title,
  Group,
  Center,
  Divider,
  rem,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useLayoutEffect } from "react";
import checkUserId from "../../utils/checkuserid";
import { IconArrowRight, IconCar, IconUsers, IconShield } from "@tabler/icons-react";

const LandingPage = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  useLayoutEffect(() => {
    checkUserId();
  }, []);

  return (
    <Container
      size={isMobile ? "sm" : "lg"}
      px={isMobile ? "md" : "xl"}
      py={isMobile ? "xl" : "80px"}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Stack align="center" gap={isMobile ? "xl" : "80px"} w="100%">
        
        {/* Hero Section */}
        <Stack align="center" gap="xl" ta="center">
          <Image src={"landingimg.png"} maw={isMobile ? 180 : 240} />
          <Stack align="center" gap="md">
            <Title 
              order={1} 
              style={{ 
                fontSize: isMobile ? "3rem" : "4.5rem",
                fontWeight: 700,
                letterSpacing: "-0.02em"
              }}
            >
              Kabbie
            </Title>
            <Text 
              size={isMobile ? "lg" : "xl"} 
              c="dimmed" 
              maw={600}
              style={{ lineHeight: 1.5 }}
            >
              Your reliable ride-sharing partner. Book rides easily or join as a driver.
            </Text>
          </Stack>
        </Stack>

        {/* Primary CTA */}
        <Stack align="center" gap="lg" w="100%" maw={400}>
          <Button
            onClick={() => {
              window.location.href = "/user/signin";
            }}
            variant="gradient"
            gradient={{ from: '#000000', to: '#333333', deg: 145 }}
            size="xl"
            radius="md"
            w="100%"
            h={60}
            style={{ fontSize: rem(18) }}
            rightSection={<IconArrowRight style={{ width: rem(20), height: rem(20) }} />}
          >
            Book a Ride Now
          </Button>
          
          <Text size="sm" c="dimmed">or</Text>
          
          <Group gap="md" w="100%">
            <Button
              onClick={() => {
                window.location.href = "/signin";
              }}
              variant="light"
              color="dark"
              size="lg"
              radius="md"
              style={{ flex: 1 }}
            >
              Driver Login
            </Button>
            
            <Button
              variant="outline"
              color="dark"
              size="lg"
              radius="md"
              style={{ flex: 1 }}
              onClick={() => {
                window.location.href = "/signup";
              }}
            >
              Join as Driver
            </Button>
          </Group>
        </Stack>

        {/* Simple Features */}
        <>
          <Divider w="100%" maw={300} />
          
          <Group justify="center" gap={isMobile ? "lg" : "xl"} w="100%">
            <Center>
              <Stack align="center" gap="xs">
                <IconCar size={isMobile ? 28 : 32} color="#666" />
                <Text size={isMobile ? "xs" : "sm"} fw={500} c="dark">Easy Booking</Text>
              </Stack>
            </Center>
            
            <Center>
              <Stack align="center" gap="xs">
                <IconUsers size={isMobile ? 28 : 32} color="#666" />
                <Text size={isMobile ? "xs" : "sm"} fw={500} c="dark">Professional Drivers</Text>
              </Stack>
            </Center>
            
            <Center>
              <Stack align="center" gap="xs">
                <IconShield size={isMobile ? 28 : 32} color="#666" />
                <Text size={isMobile ? "xs" : "sm"} fw={500} c="dark">Safe & Reliable</Text>
              </Stack>
            </Center>
          </Group>
        </>
        
      </Stack>
    </Container>
  );
};

export default LandingPage;
